export const startWindow = 'startWindow';
export const endWindow = 'endWindow';
export const COMMENT_FORM_QUESTION_ID = 'COVAL';

export const protocolStatus = {
  active: 'Active',
  draft: 'Draft',
  retired: 'Retired'
};
